<template>
  <div class="invoice-profile-page" v-loading="loading">
    <div class="page-head">
      <div>
        <div class="head-title">开票信息维护</div>
        <div class="head-sub">维护常用开票信息，结算时可快速选择</div>
      </div>
      <el-button type="primary" icon="el-icon-plus" @click="openCreate">新增开票信息</el-button>
    </div>

    <div v-if="profiles.length" class="cards-grid">
      <div v-for="item in profiles" :key="item.id" class="invoice-card" :class="{ 'is-main': item.isMain === 'Y' }">
        <div class="card-top">
          <div class="card-title-wrap">
            <span class="card-title">{{ item.buyerName || '-' }}</span>
             <el-tag size="mini" :type="item.invoiceType === '1' ? 'danger' : 'success'">
              {{ invoiceTypeShortText(item.invoiceType) }}
             </el-tag>
            <el-tag v-if="item.isMain === 'Y'" size="mini" type="success">默认</el-tag>
          </div>
          <div class="card-actions">
            <el-button type="text" @click="openEdit(item)">编辑</el-button>
            <el-button v-if="item.isMain !== 'Y'" type="text" @click="setDefault(item)">设为默认</el-button>
            <el-button type="text" class="danger" @click="removeItem(item)">删除</el-button>
          </div>
        </div>

        <div class="card-body">
          <div class="info-row">
            <span class="label">发票类型</span>
            <span class="value">{{ invoiceTypeText(item.invoiceType) }}</span>
          </div>
          <div class="info-row">
            <span class="label">纳税人识别号</span>
            <span class="value">{{ item.buyerTaxNo || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="label">开户信息</span>
            <span class="value">{{ formatBankInfo(item) }}</span>
          </div>
          <div class="info-row">
            <span class="label">联系方式</span>
            <span class="value">{{ item.buyerPhone || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="label">邮箱</span>
            <span class="value">{{ item.email || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="label">地址</span>
            <span class="value">{{ item.buyerAddress || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="label">备注</span>
            <span class="value">{{ item.remark || '-' }}</span>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="empty-wrap">
      <el-empty description="暂无开票信息"></el-empty>
    </div>

    <el-dialog
      :title="dialogMode === 'create' ? '新增开票信息' : '编辑开票信息'"
      :visible.sync="dialogVisible"
      width="760px"
      :close-on-click-modal="false"
      class="Summit-dialog"
    >
      <el-form ref="formRef" :model="form" :rules="rules" label-width="120px" class="invoice-form">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="开票名称" prop="buyerName">
              <el-input v-model="form.buyerName" maxlength="255" placeholder="请输入开票名称" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票类型" prop="invoiceType">
              <el-select v-model="form.invoiceType" placeholder="请选择发票类型" style="width: 100%" clearable>
                <el-option label="增值税专用发票" value="1" />
                <el-option label="增值税普通发票" value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纳税人识别号" prop="buyerTaxNo">
              <el-input v-model="form.buyerTaxNo" maxlength="255" placeholder="请输入纳税人识别号" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式" prop="buyerPhone">
              <el-input v-model="form.buyerPhone" maxlength="255" placeholder="请输入联系方式" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户行" prop="buyerBankName">
              <el-input v-model="form.buyerBankName" maxlength="255" placeholder="请输入开户行" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户账号" prop="buyerBankAccount">
              <el-input v-model="form.buyerBankAccount" maxlength="255" placeholder="请输入开户账号" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地址" prop="buyerAddress">
              <el-input v-model="form.buyerAddress" maxlength="255" placeholder="请输入地址" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="form.email" maxlength="255" placeholder="请输入邮箱" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="form.remark" type="textarea" :rows="3" maxlength="255" show-word-limit placeholder="请输入备注" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="默认开票信息" prop="isMain">
              <el-switch
                v-model="mainSwitch"
                active-text="是"
                inactive-text="否"
                @change="syncMainStatus"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitting" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  getInvoiceProfileList,
  modifyInvoiceProfile,
  removeInvoiceProfile,
  setDefaultInvoiceProfile
} from '@/assets/API/invoiceProfile'

const defaultForm = () => ({
  id: '',
  customerId: '',
  buyerName: '',
  buyerTaxNo: '',
  buyerPhone: '',
  buyerBankName: '',
  buyerBankAccount: '',
  buyerAddress: '',
  email: '',
  invoiceType: '',
  remark: '',
  isMain: 'N'
})

export default {
  name: 'InvoiceProfileManagement',
  computed: {
    ...mapState('user', ['userInfo'])
  },
  data() {
    return {
      loading: false,
      submitting: false,
      dialogVisible: false,
      dialogMode: 'create',
      profiles: [],
      form: defaultForm(),
      mainSwitch: false,
      rules: {
        buyerName: [{ required: true, message: '请输入开票名称', trigger: 'blur' }],
        invoiceType: [{ required: true, message: '请选择发票类型', trigger: 'change' }],
        buyerTaxNo: [{ required: true, message: '请输入纳税人识别号', trigger: 'blur' }],
        email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    if (!this.ensureLoginValid()) {
      return
    }
    this.loadList()
  },
  methods: {
    getCustomerId() {
      return this.userInfo && (this.userInfo.id || this.userInfo.userId)
        ? (this.userInfo.id || this.userInfo.userId)
        : ''
    },
    ensureLoginValid() {
      const customerId = this.getCustomerId()
      if (customerId) {
        return true
      }
      this.$message.error('登录失效，请重新登录')
      this.$store.dispatch('user/logout').finally(() => {
        this.$router.replace('/login')
      })
      return false
    },
    invoiceTypeText(type) {
      if (String(type) === '1') return '增值税专用发票'
      if (String(type) === '2') return '增值税普通发票'
      return '-'
    },
    invoiceTypeShortText(type) {
      if (String(type) === '1') return '专票'
      if (String(type) === '2') return '普票'
      return '-'
    },
    formatBankInfo(item) {
      const bankName = item && item.buyerBankName ? item.buyerBankName : '-'
      const bankAccount = item && item.buyerBankAccount ? item.buyerBankAccount : '-'
      return `${bankName} / ${bankAccount}`
    },
    loadList() {
      if (!this.ensureLoginValid()) {
        return
      }
      this.loading = true
      const customerId = this.getCustomerId()
      getInvoiceProfileList({ customerId })
        .then(res => {
          if (res.code === 200) {
            this.profiles = Array.isArray(res.data) ? res.data : []
          } else {
            this.$message.error(res.msg || '获取开票信息失败')
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    openCreate() {
      if (!this.ensureLoginValid()) {
        return
      }
      this.dialogMode = 'create'
      const customerId = this.getCustomerId()
      const loginName = this.userInfo && (this.userInfo.realName || this.userInfo.username)
      const loginPhone = this.userInfo && (this.userInfo.phonenum || this.userInfo.phone)
      const loginEmail = this.userInfo && this.userInfo.email
      this.form = {
        ...defaultForm(),
        customerId,
        buyerName: loginName || '',
        buyerPhone: loginPhone || '',
        email: loginEmail || ''
      }
      this.mainSwitch = false
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate()
      })
    },
    openEdit(item) {
      if (!this.ensureLoginValid()) {
        return
      }
      this.dialogMode = 'edit'
      this.form = { ...defaultForm(), ...item }
      this.mainSwitch = this.form.isMain === 'Y'
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate()
      })
    },
    syncMainStatus(val) {
      this.form.isMain = val ? 'Y' : 'N'
    },
    submitForm() {
      if (!this.ensureLoginValid()) {
        return
      }
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        this.submitting = true
        const payload = {
          ...this.form,
          customerId: this.getCustomerId(),
          isMain: this.mainSwitch ? 'Y' : 'N'
        }
        modifyInvoiceProfile(payload)
          .then(res => {
            if (res.code === 200) {
              this.$message.success(this.dialogMode === 'create' ? '新增成功' : '编辑成功')
              this.dialogVisible = false
              this.loadList()
            } else {
              this.$message.error(res.msg || '操作失败')
            }
          })
          .finally(() => {
            this.submitting = false
          })
      })
    },
    setDefault(item) {
      this.$confirm('确认将该条记录设为默认开票信息吗？', '提示', {
        type: 'warning'
      }).then(() => {
        setDefaultInvoiceProfile(item.id).then(res => {
          if (res.code === 200) {
            this.$message.success('设置成功')
            this.loadList()
          } else {
            this.$message.error(res.msg || '设置失败')
          }
        })
      }).catch(() => {})
    },
    removeItem(item) {
      this.$confirm('确认删除该开票信息吗？删除后不可恢复。', '提示', {
        type: 'warning'
      }).then(() => {
        removeInvoiceProfile(item.id).then(res => {
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.loadList()
          } else {
            this.$message.error(res.msg || '删除失败')
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped lang="scss">
.invoice-profile-page {
  margin-top: 35px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 3px 5px rgba(228, 235, 247, 0.5);
  padding: 22px;
  min-height: calc(100vh - 140px);

  .page-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .head-title {
      font-size: 22px;
      color: #2c3e50;
      line-height: 30px;
      font-weight: 600;
    }

    .head-sub {
      margin-top: 6px;
      font-size: 13px;
      color: #7f8c8d;
    }
  }

  .cards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
    gap: 16px;
  }

  .invoice-card {
    border: 1px solid #e9edf3;
    border-radius: 12px;
    padding: 16px;
    background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
    transition: all 0.2s ease;

    &:hover {
      border-color: #b8d7f7;
      box-shadow: 0 8px 20px rgba(43, 133, 229, 0.12);
      transform: translateY(-2px);
    }

    &.is-main {
      border-color: #67c23a;
      box-shadow: 0 8px 20px rgba(103, 194, 58, 0.16);
    }

    .card-top {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-bottom: 12px;

      .card-title-wrap {
        display: flex;
        align-items: center;
        gap: 8px;

        .card-title {
          font-size: 16px;
          font-weight: 600;
          color: #1f2d3d;
          max-width: 200px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .card-actions {
        .danger {
          color: #f56c6c;
        }
      }
    }

    .card-body {
      .info-row {
        display: flex;
        margin-top: 8px;
        font-size: 13px;

        .label {
          flex: 0 0 90px;
          color: #8a97a5;
        }

        .value {
          flex: 1;
          color: #34495e;
          word-break: break-all;
          line-height: 18px;
        }
      }
    }
  }

  .empty-wrap {
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ::v-deep .el-dialog__body {
    padding-top: 10px;
  }
}
</style>
